<template>
  <header class="site-header">
    <div class="header-inner">
      <nav class="nav" aria-label="Primary">
        <router-link to="/" class="nav-link nav-link--icon">
          <svg class="nav-link__icon" viewBox="0 0 24 24" aria-hidden="true">
            <path
                fill="currentColor"
                d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8h5Z"
            />
          </svg>
          <span>Home</span>
        </router-link>
        <router-link to="/shop" class="nav-link nav-link--icon">
          <svg class="nav-link__icon" viewBox="0 0 24 24" aria-hidden="true">
            <path
                fill="currentColor"
                d="M6 2h12l1.5 6H22v2h-1.11l-1.2 8.42A2 2 0 0 1 17.71 20H6.29a2 2 0 0 1-1.98-1.58L3.11 10H2V8h2.5L6 2Zm2.55 6h6.9l-.75-4h-5.4l-.75 4ZM5.14 10l1 7h11.72l1-7H5.14Z"
            />
          </svg>
          <span>Shop</span>
        </router-link>

        <router-link to="/library" class="nav-link nav-link--icon">
          <svg class="nav-link__icon" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="currentColor" d="M4 4h6v16H4V4Zm10 0h6v16h-6V4ZM6 6v12h2V6H6Zm10 0v12h2V6h-2Z" />
          </svg>
          <span>Library</span>
        </router-link>

        <router-link :to="{ path: '/shop', query: { cart: 'open' } }" class="nav-link nav-link--icon">
          <svg class="nav-link__icon" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="currentColor" d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2Zm10 0c-1.1 0-1.99.9-1.99 2S15.9 22 17 22s2-.9 2-2-.9-2-2-2ZM7.17 14.75l.62-1.13h7.45c.75 0 1.4-.41 1.74-1.03L20.8 5.6A1 1 0 0 0 19.93 4H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.45A2 2 0 0 0 7 17h12v-2H7l.17-.25Z" />
          </svg>
          <span>Cart<span v-if="cartQuantity"> ({{ cartQuantity }})</span></span>
        </router-link>

        <details ref="navMenu" class="nav-menu">
          <summary class="nav-menu__button">
            <svg class="nav-link__icon" viewBox="0 0 24 24" aria-hidden="true">
              <path
                  fill="currentColor"
                  d="M4 6h16v2H4V6Zm0 5h16v2H4v-2Zm0 5h16v2H4v-2Z"
              />
            </svg>
            <span>More</span>
          </summary>
          <div class="nav-menu__panel">
            <router-link to="/about" class="nav-menu__link">About us</router-link>
            <router-link to="/shipping" class="nav-menu__link">Shipping</router-link>
            <router-link to="/returns" class="nav-menu__link">Returns</router-link>
            <router-link to="/contact" class="nav-menu__link">Contact</router-link>
          </div>
        </details>
      </nav>

      <div class="header-actions">
        <router-link to="/" class="site-title">Bumblefox UK</router-link>
        <button
            class="theme-toggle"
            type="button"
            :aria-label="themeToggleLabel"
            :title="themeToggleLabel"
            @click="toggleTheme"
        >
          <svg v-if="theme === 'light'" class="theme-toggle__icon" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="currentColor" d="M12 18a6 6 0 1 1 0-12 6 6 0 0 1 0 12Zm0-16h1v3h-2V2h1Zm0 17h1v3h-2v-3ZM2 11h3v2H2v-2Zm17 0h3v2h-3v-2ZM4.22 5.64l1.42-1.42 2.12 2.12-1.42 1.42-2.12-2.12Zm12.02 12.02 1.42-1.42 2.12 2.12-1.42 1.42-2.12-2.12ZM18.36 4.22l1.42 1.42-2.12 2.12-1.42-1.42 2.12-2.12ZM6.34 16.24l1.42 1.42-2.12 2.12-1.42-1.42 2.12-2.12Z" />
          </svg>
          <svg v-else class="theme-toggle__icon" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="currentColor" d="M20.72 15.42A9 9 0 0 1 8.58 3.28 9 9 0 1 0 20.72 15.42ZM12 21a7 7 0 0 1-5.3-11.57 11 11 0 0 0 7.87 7.87A6.96 6.96 0 0 1 12 21Z" />
          </svg>
          <span>{{ theme === "light" ? "Light" : "Dark" }}</span>
        </button>
      </div>
    </div>
  </header>

  <div id="app">
    <main>
      <router-view/>
    </main>

    <a
        v-if="messengerUrl"
        class="messenger-button"
        :href="messengerUrl"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Message Bumblefox UK on Facebook Messenger"
    >
      <svg
          class="messenger-button__icon"
          viewBox="0 0 24 24"
          aria-hidden="true"
      >
        <path
            fill="currentColor"
            d="M12 2C6.48 2 2 6.15 2 11.27c0 2.91 1.45 5.5 3.71 7.2V22l3.39-1.86c.92.25 1.89.39 2.9.39 5.52 0 10-4.15 10-9.26S17.52 2 12 2Zm1.07 12.48-2.55-2.72-4.98 2.72L11 8.68l2.61 2.72 4.92-2.72-5.46 5.8Z"
        />
      </svg>
      <span>Message us</span>
    </a>

    <footer>
      <div class="footer-content">

        <div class="customer-service">
          <h4>Customer Service</h4>
          <ul>
            <li><a href="/returns">Returns Policy</a></li>
            <li><a href="/shipping">Shipping Info</a></li>
            <li><a href="/contact">Contact Us</a></li>
          </ul>
        </div>

        <div class="licences">
          <a
              href="https://www.instagram.com/kekreationsart/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Kekreations Art on Instagram"
          >
            <img src="./assets/kekreations.png" alt="Kekreations Art" class="licence-image"/>
          </a>
          <a
              href="https://www.instagram.com/cinderwing3d/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Cinderwing3D on Instagram"
          >
            <img src="./assets/cinderwings.png" alt="Cinderwing3D" id="licence-image-cinderwings"/>
          </a>
          <a
              href="https://www.instagram.com/mysticsaige/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Mystic Saige on Instagram"
          >
            <img src="./assets/mystic-sage.png" alt="Mystic Saige" class="licence-image-mystic-sage"/>
          </a>
          <a
              href="https://www.instagram.com/krakendesigns3d/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Kraken Designs 3D on Instagram"
          >
            <img src="./assets/kraken-designs.png" alt="Kraken Designs 3D" class="licence-image"/>
          </a>
          <a
              href="https://www.instagram.com/bloblab3d/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Blob Lab 3D on Instagram"
          >
            <img src="./assets/bloblab.png" alt="Blob Lab 3D" class="licence-image-mystic-sage"/>
          </a>
          <a
              href="https://www.instagram.com/pepunki_creatures/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Pepunki Creatures on Instagram"
          >
            <img src="./assets/pepunki.png" alt="Pepunki Creatures" class="licence-image-smaller"/>
          </a>
          <a
              href="https://www.instagram.com/akshan_designs/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Akshan Designs on Instagram"
          >
            <img src="./assets/akshan.png" alt="Akshan Designs" class="licence-image-smaller"/>
          </a>
          <a
              href="https://www.instagram.com/goldenkaeru/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Golden Kaeru Designs on Instagram"
          >
            <img src="./assets/golden_kaeru.png" alt="Golden Kaeru" class="licence-image-smaller"/>
          </a>
          <a
              href="https://www.instagram.com/happyflexipets/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Happy Flexi pets Designs on Instagram"
          >
            <img src="./assets/happy_flexi.png" alt="Happy Flexi pets" class="licence-image-smaller"/>
          </a>
        </div>

      </div>

      <p>&copy; 2025 Bumblefox UK. All rights reserved.</p>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cartQuantity: 0,
      theme: document.documentElement.dataset.theme || "light",
    };
  },

  mounted() {
    document.addEventListener("click", this.onDocumentClick);
    window.addEventListener("storage", this.updateCartQuantity);
    window.addEventListener("bumblefox-cart-updated", this.updateCartQuantity);
    this.updateCartQuantity();
  },

  beforeUnmount() {
    document.removeEventListener("click", this.onDocumentClick);
    window.removeEventListener("storage", this.updateCartQuantity);
    window.removeEventListener("bumblefox-cart-updated", this.updateCartQuantity);
  },

  computed: {
    themeToggleLabel() {
      return `Switch to ${this.theme === "light" ? "dark" : "light"} mode`;
    },

    messengerUrl() {
      const configuredUrl = process.env.VUE_APP_FACEBOOK_MESSENGER_URL?.trim();

      if (!configuredUrl) {
        return "";
      }

      try {
        const url = new URL(configuredUrl);
        const allowedHosts = new Set([
          "m.me",
          "www.messenger.com",
          "messenger.com",
          "www.facebook.com",
          "facebook.com",
        ]);

        return url.protocol === "https:" && allowedHosts.has(url.hostname)
            ? url.toString()
            : "";
      } catch {
        return "";
      }
    },
  },

  methods: {
    toggleTheme() {
      this.theme = this.theme === "light" ? "dark" : "light";
      document.documentElement.dataset.theme = this.theme;
      document.documentElement.style.colorScheme = this.theme;

      try {
        localStorage.setItem("bumblefox-theme", this.theme);
      } catch {
        return;
      }
    },

    updateCartQuantity() {
      try {
        const cart = JSON.parse(localStorage.getItem("bumblefox-square-cart") || "[]");
        this.cartQuantity = Array.isArray(cart)
            ? cart.reduce((total, line) => total + (Number(line.quantity) || 0), 0)
            : 0;
      } catch {
        this.cartQuantity = 0;
      }
    },

    onDocumentClick(event) {
      const navMenu = this.$refs.navMenu;

      if (!navMenu || !navMenu.open) {
        return;
      }

      if (navMenu.contains(event.target)) {
        return;
      }

      navMenu.open = false;
    },
  },
};
</script>

<style>
/* Base styling */
:root {
  --page-bg: #fff8ef;
  --surface: #ffffff;
  --surface-soft: #fff3e4;
  --surface-muted: #f6f2ed;
  --text: #2c3e50;
  --text-soft: #5d5b70;
  --heading: #2e2d61;
  --border: #d7d3de;
  --header-bg: #ffd674;
  --footer-bg: #efb26e;
  --shadow: rgba(46, 45, 97, 0.12);
  --accent: #e86a92;
}

:root[data-theme="dark"] {
  --page-bg: #151421;
  --surface: #211f30;
  --surface-soft: #1b1928;
  --surface-muted: #292638;
  --text: #f4edf2;
  --text-soft: #c5bdca;
  --heading: #fff1bd;
  --border: #454057;
  --header-bg: #29243a;
  --footer-bg: #201c2d;
  --shadow: rgba(0, 0, 0, 0.36);
  --accent: #ff8daf;
}

html,
body {
  height: 100%;
  margin: 0;
  background: var(--page-bg);
  color: var(--text);
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  text-align: center;
  background: var(--page-bg);
  color: var(--text);
  transition: background-color 0.25s ease, color 0.25s ease;
}

.site-header {
  position: sticky;
  transform: translateZ(0);
  top: 0;
  z-index: 9999;
  background-color: var(--header-bg);
  padding: 20px;
  box-shadow: 0 8px 30px var(--shadow);
  transition: background-color 0.25s ease, box-shadow 0.25s ease;
}

.header-inner {
  display: flex;
  align-items: center; /* vertical alignment */
  justify-content: space-between; /* left group + right title */
  max-width: 1100px;
  margin: 0 auto;
}

.site-title {
  margin: 0;
  color: #2e2d61;
  font-size: 22px;
  font-weight: 800;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.theme-toggle {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 40px;
  padding: 0 12px;
  border: 1px solid rgba(46, 45, 97, 0.18);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.3);
  color: #2e2d61;
  font: inherit;
  font-size: 0.88rem;
  font-weight: 800;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.theme-toggle:hover {
  background: rgba(255, 255, 255, 0.48);
  transform: translateY(-1px);
}

.theme-toggle:focus-visible {
  outline: 3px solid var(--accent);
  outline-offset: 3px;
}

.theme-toggle__icon {
  width: 18px;
  height: 18px;
}

.nav {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}

.nav-link {
  color: #2e2d61;
  text-decoration: none;
  font-weight: 700;
}

.nav-link--icon {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 40px;
  padding: 0 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.24);
}

.nav-link--icon:hover,
.nav-link--icon.router-link-active {
  background: rgba(255, 255, 255, 0.38);
  text-decoration: none;
}

.nav-link.router-link-active {
  text-decoration: underline;
}

.nav-link__icon {
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
}

.nav-menu {
  position: relative;
}

.nav-menu > summary {
  list-style: none;
}

.nav-menu > summary::-webkit-details-marker {
  display: none;
}

.nav-menu__button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 40px;
  padding: 0 12px;
  border-radius: 999px;
  border: 0;
  background: rgba(255, 255, 255, 0.24);
  color: #2e2d61;
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}

.nav-menu__button:hover,
.nav-menu[open] .nav-menu__button {
  background: rgba(255, 255, 255, 0.38);
}

.nav-menu__panel {
  position: absolute;
  left: 0;
  top: calc(100% + 10px);
  z-index: 10000;
  display: grid;
  min-width: 170px;
  padding: 8px;
  border: 1px solid rgba(46, 45, 97, 0.15);
  border-radius: 14px;
  background: var(--surface);
  box-shadow: 0 16px 40px rgba(46, 45, 97, 0.16);
}

.nav-menu__link {
  padding: 10px 12px;
  border-radius: 10px;
  color: #2e2d61;
  text-decoration: none;
  font-weight: 700;
}

.nav-menu__link:hover,
.nav-menu__link.router-link-active {
  background: rgba(230, 122, 153, 0.12);
}

.messenger-button {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 9998;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 48px;
  padding: 0 18px;
  border-radius: 24px;
  background: #0866ff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.24);
  color: #fff;
  font-size: 15px;
  font-weight: 800;
  text-decoration: none;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.messenger-button:hover {
  background: #0057dc;
  transform: translateY(-2px);
}

.messenger-button:focus-visible {
  outline: 3px solid #2e2d61;
  outline-offset: 3px;
}

.messenger-button__icon {
  width: 24px;
  height: 24px;
  flex: 0 0 auto;
}

h1 {
  color: #2e2d61;
  margin-bottom: 10px;
}

.menu-details h3 {
  margin: 10px 0 5px;
}

.menu-details p {
  margin: 5px 0;
}

.menu-note a {
  color: #e86a92;
  text-decoration: none;
}

.menu-note a:hover {
  text-decoration: underline;
}

#licence-image-cinderwings {
  width: auto;
  height: 90px;
  display: block;
}

.licence-image {
  width: auto;
  height: 110px;
  border-radius: 50%;
  display: block;
}

.licence-image-smaller {
  width: auto;
  height: 95px;
  border-radius: 50%;
  display: block;
}

.licence-image-mystic-sage {
  width: auto;
  padding-left: 15px;
  height: 95px;
  display: block;
}

.licences {
  display: flex;
  align-items: center; /* vertically centers */
  justify-content: center; /* centers horizontally */
  gap: 10px; /* space between images */
  flex-wrap: wrap; /* single line when possible, wraps on small screens */
}

footer {
  background-color: var(--footer-bg);
  padding: 10px;
  color: var(--text-soft);
  font-size: 14px;
}

.footer-content {
  //display: flex;
  //justify-content: space-between;
  //align-items: flex-start;
  //flex-wrap: wrap;
  //gap: 20px;
}

.customer-service h4 {
  margin-bottom: 10px;
  font-size: 16px;
}

.customer-service ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.customer-service li {
  margin-bottom: 6px;
}

.customer-service a {
  text-decoration: none;
  color: var(--text);
}

:root[data-theme="dark"] .site-title,
:root[data-theme="dark"] .nav-link,
:root[data-theme="dark"] .nav-menu__button,
:root[data-theme="dark"] .theme-toggle {
  color: #fff1bd;
}

:root[data-theme="dark"] .nav-link--icon,
:root[data-theme="dark"] .nav-menu__button,
:root[data-theme="dark"] .theme-toggle {
  border-color: rgba(255, 241, 189, 0.16);
  background: rgba(255, 255, 255, 0.07);
}

:root[data-theme="dark"] .nav-link--icon:hover,
:root[data-theme="dark"] .nav-link--icon.router-link-active,
:root[data-theme="dark"] .nav-menu__button:hover,
:root[data-theme="dark"] .nav-menu[open] .nav-menu__button,
:root[data-theme="dark"] .theme-toggle:hover {
  background: rgba(255, 255, 255, 0.13);
}

:root[data-theme="dark"] h1,
:root[data-theme="dark"] h2,
:root[data-theme="dark"] h3,
:root[data-theme="dark"] h4,
:root[data-theme="dark"] .product-title,
:root[data-theme="dark"] .product-description h2,
:root[data-theme="dark"] .product-options h2 {
  color: var(--heading);
}

:root[data-theme="dark"] .home-section,
:root[data-theme="dark"] .shop-section,
:root[data-theme="dark"] .library-section,
:root[data-theme="dark"] .product-page,
:root[data-theme="dark"] .about-section,
:root[data-theme="dark"] .info-page,
:root[data-theme="dark"] .contact-page {
  background: var(--page-bg);
  color: var(--text);
}

:root[data-theme="dark"] .shop-card,
:root[data-theme="dark"] .library-card,
:root[data-theme="dark"] .product-details,
:root[data-theme="dark"] .info-card,
:root[data-theme="dark"] .contact-card,
:root[data-theme="dark"] .return-policy,
:root[data-theme="dark"] .cart-panel,
:root[data-theme="dark"] .modal-content,
:root[data-theme="dark"] .quote-dialog,
:root[data-theme="dark"] .nav-menu__panel {
  border-color: var(--border);
  background: var(--surface);
  box-shadow: 0 16px 40px var(--shadow);
  color: var(--text);
}

:root[data-theme="dark"] input,
:root[data-theme="dark"] select,
:root[data-theme="dark"] textarea,
:root[data-theme="dark"] .filter-button,
:root[data-theme="dark"] .shop-pagination button,
:root[data-theme="dark"] .library-pagination button,
:root[data-theme="dark"] .thumbnail-button {
  border-color: var(--border);
  background: var(--surface-muted);
  color: var(--text);
}

:root[data-theme="dark"] input::placeholder,
:root[data-theme="dark"] textarea::placeholder {
  color: #9991a5;
}

:root[data-theme="dark"] .shop-subtitle,
:root[data-theme="dark"] .shop-updated,
:root[data-theme="dark"] .shop-loading,
:root[data-theme="dark"] .shop-results,
:root[data-theme="dark"] .shop-empty,
:root[data-theme="dark"] .library-subtitle,
:root[data-theme="dark"] .product-meta,
:root[data-theme="dark"] .product-description,
:root[data-theme="dark"] .price-note {
  color: var(--text-soft);
}

:root[data-theme="dark"] .shop-image-wrap,
:root[data-theme="dark"] .product-image-wrap,
:root[data-theme="dark"] .library-image-wrap,
:root[data-theme="dark"] .shop-card-content,
:root[data-theme="dark"] .library-card-content,
:root[data-theme="dark"] .cart-item {
  background: var(--surface-muted);
}

:root[data-theme="dark"] .filter-button.active,
:root[data-theme="dark"] .cart-button,
:root[data-theme="dark"] .add-to-cart-button,
:root[data-theme="dark"] .checkout-button,
:root[data-theme="dark"] .info-action,
:root[data-theme="dark"] .contact-link {
  border-color: #f2bd62;
  background: #f2bd62;
  color: #211b2c;
}

:root[data-theme="dark"] .nav-menu__link {
  color: var(--heading);
}

:root[data-theme="dark"] .shop-error {
  border-color: #8f555e;
  background: #3b2229;
  color: #ffc5cd;
}

:root[data-theme="dark"] .checkout-success {
  border-color: #527d60;
  background: #1c3525;
  color: #b9edc7;
}

:root[data-theme="dark"] img {
  filter: brightness(0.92);
}

.customer-service a:hover {
  text-decoration: underline;
}

@media (max-width: 600px) {
  .site-header {
    padding: 10px 12px;
  }

  .header-inner {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .site-title {
    order: -1;
    align-self: center;
    font-size: 20px;
    text-decoration: none;
  }

  .header-actions {
    order: -1;
    justify-content: space-between;
  }

  .header-actions .site-title {
    order: initial;
    align-self: auto;
  }

  .nav {
    flex-wrap: nowrap;
    gap: 6px;
    overflow-x: auto;
    padding: 2px 0 5px;
    scrollbar-width: thin;
  }

  .nav-link--icon,
  .nav-menu__button {
    flex: 0 0 auto;
    min-height: 38px;
    padding: 0 9px;
    font-size: 0.9rem;
  }

  .nav-menu__panel {
    right: 0;
    left: auto;
  }

  .messenger-button {
    right: 16px;
    bottom: 16px;
    width: 48px;
    padding: 0;
    justify-content: center;
  }

  .messenger-button span {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
}
</style>
